import React, { useState } from "react";
import { useSelector } from "react-redux";
import { selectCurrentMap } from "../../../store/mapStore/mapSelectors";
import { getMapScale } from "../../../helpers/mapHelpers";
import AddPropsToChildren from "../../../components/AddPropsToChildren";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

import classes from './index.module.scss';

const MapLegend = ({ children, ...props }) => {
  const [ scale, setScale ] = useState(1);
  const currentMapModel = useSelector(selectCurrentMap);
  const mapScale = getMapScale(currentMapModel);

  const variants = [ '1m', '10m', '100m', '1km', '10km', '100km' ];
  let title = '';

  const width = variants.reduce((previousValue, currentValue, index) => {
    if (previousValue > 50) {
      return previousValue;
    }

    const amountOfMeters = Math.pow(10, index);
    title = currentValue;
    return amountOfMeters * mapScale * scale;
  }, 0);

  const onZoomLegend = (newScale) => {
    setScale(newScale);
  }

  const extraProps = {
    onZoomHandlers: [ onZoomLegend ],
    mapChildren: props.mapChildren,
  }

  return (
    <>
      <Grid container className={classes.legend}>
        <Grid item>
          <Typography variant='body1'>{title}</Typography>
        </Grid>
        <Grid item className={classes.legendLine} style={{ width: `${width}px` }}>
          &nbsp;
        </Grid>
      </Grid>
      <AddPropsToChildren
        extraProps={extraProps}
        {...props}
      >
        {children}
      </AddPropsToChildren>
    </>
  )
}

export default MapLegend;